module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cUNi1"))).then(() => parcelRequire('1iHdE'));